import React from 'react';

function AddressBlock({ address }) {
    if (!address) {
        return null;
    }

    return (
        <div className="uk-margin">
            {address.company ? <div>{address.company}</div> : address.isCompany && <div>{address.companyName}</div>}
            <div>{[address.salutation, address.titel, address.firstName, address.lastName].join(' ')}</div>
            {address.street && <div>{address.street}</div>}
            {address.additionalAddressInfo && <div>{address.additionalAddressInfo}</div>}
            {address.zipCode && address.city && (
                <div>
                    {address.zipCode} {address.city}
                </div>
            )}
        </div>
    );
}

export default AddressBlock;
